"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSecondaryText = exports.StyledPrimaryText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PrimaryText = _interopRequireDefault(require("../../TextElements/BasicTextElements/PrimaryText"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledPrimaryText = (0, _styledComponents.default)(_PrimaryText.default).withConfig({
  displayName: "AlertModalBasestyles__StyledPrimaryText",
  componentId: "sc-1y5x78w-0"
})(["font-weight:700;"]);
exports.StyledPrimaryText = StyledPrimaryText;
var StyledSecondaryText = (0, _styledComponents.default)(_ParagraphText.default).withConfig({
  displayName: "AlertModalBasestyles__StyledSecondaryText",
  componentId: "sc-1y5x78w-1"
})(["padding-top:.25rem;padding-bottom:0;&:first-child{padding-top:", ";}&:last-child{padding-bottom:", ";}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
});
exports.StyledSecondaryText = StyledSecondaryText;